<template>
  <div v-if="visible" class="cookie-banner" role="dialog" aria-live="polite" :aria-label="$t('app.cookieBanner.ariaLabel')">
    <div class="cookie-banner__content">
      <p class="cookie-banner__text">
        {{ $t('app.cookieBanner.text') }}
        <router-link class="cookie-link" :to="{ name: 'CookiePolicy' }">{{ $t('app.cookieBanner.readCookiePolicy') }}</router-link>
        {{ $t('app.cookieBanner.and') }}
        <router-link class="cookie-link" :to="{ name: 'PrivacyPolicy' }">{{ $t('app.cookieBanner.readPrivacyPolicy') }}</router-link>.
      </p>
      <div class="cookie-banner__actions">
        <button class="cookie-accept" @click="accept" :aria-label="$t('app.cookieBanner.acceptAriaLabel')">{{ $t('app.cookieBanner.accept') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsentBanner',
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    try {
      const consent = localStorage.getItem('cookie_consent')
      this.visible = consent !== 'accepted'
    } catch (e) {
      this.visible = true
    }
  },
  methods: {
    accept () {
      try {
        localStorage.setItem('cookie_consent', 'accepted')
      } catch (e) {}
      this.visible = false
      this.$emit('accepted')
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(29, 29, 31, 0.96);
  color: #fff;
}
.cookie-banner__content {
  max-width: 1080px;
  margin: 0 auto;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}
.cookie-banner__text {
  margin: 0;
  line-height: 1.6;
  flex: 1;
}
.cookie-link { color: #c9595e !important; text-decoration: underline; }
.cookie-banner__actions { display: flex; gap: 8px; margin-left: auto; }
.cookie-accept {
  appearance: none;
  border: 0;
  background: #cf444b;
  color: #fff;
  padding: 10px 14px;
  border-radius: 6px;
  cursor: pointer;
}
@media (min-width: 768px) {
  .cookie-banner__content { flex-direction: row; align-items: center; justify-content: space-between; }
}
</style>


